import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0438d560"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mask" }, null, -1));
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon" }, null, -1));
const _hoisted_3 = [
    _hoisted_1,
    _hoisted_2
];
import utils from '@utils/index';
export default /*#__PURE__*/ _defineComponent({
    props: {
        desc: {
            type: String,
            default: ''
        },
        cover: {
            type: String,
            default: ''
        },
        item: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    setup(__props) {
        const props = __props;
        const playVideo = (item) => {
            if (utils.isApp()) {
                utils.postMessage({
                    type: "open_detail",
                    id: item.albumId
                });
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "study-task-course",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (playVideo(__props.item)), ["stop"]))
            }, [
                _withDirectives(_createElementVNode("div", { class: "desc" }, _toDisplayString(__props.desc), 513), [
                    [_vShow, __props.desc]
                ]),
                _withDirectives(_createElementVNode("div", {
                    class: "cover",
                    style: _normalizeStyle({ backgroundImage: 'url(' + __props.cover + ')' })
                }, _hoisted_3, 4), [
                    [_vShow, __props.cover]
                ])
            ]));
        };
    }
});
